function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageresize/imageresizehandles
 */
import { Plugin } from 'ckeditor5/src/core';
import { WidgetResize } from 'ckeditor5/src/widget';
import ImageLoadObserver from '../image/imageloadobserver';
var RESIZABLE_IMAGES_CSS_SELECTOR = 'figure.image.ck-widget > img,' + 'figure.image.ck-widget > a > img,' + 'span.image-inline.ck-widget > img';
var IMAGE_WIDGETS_CLASSES_MATCH_REGEXP = /(image|image-inline)/;
var RESIZED_IMAGE_CLASS = 'image_resized';
/**
 * The image resize by handles feature.
 *
 * It adds the ability to resize each image using handles or manually by
 * {@link module:image/imageresize/imageresizebuttons~ImageResizeButtons} buttons.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageResizeHandles = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageResizeHandles, _Plugin);

  var _super = _createSuper(ImageResizeHandles);

  function ImageResizeHandles() {
    _classCallCheck(this, ImageResizeHandles);

    return _super.apply(this, arguments);
  }

  _createClass(ImageResizeHandles, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var command = this.editor.commands.get('resizeImage');
      this.bind('isEnabled').to(command);

      this._setupResizerCreator();
    }
    /**
     * Attaches the listeners responsible for creating a resizer for each image, except for images inside the HTML embed preview.
     *
     * @private
     */

  }, {
    key: "_setupResizerCreator",
    value: function _setupResizerCreator() {
      var _this = this;

      var editor = this.editor;
      var editingView = editor.editing.view;
      editingView.addObserver(ImageLoadObserver);
      this.listenTo(editingView.document, 'imageLoaded', function (evt, domEvent) {
        // The resizer must be attached only to images loaded by the `ImageInsert`, `ImageUpload` or `LinkImage` plugins.
        if (!domEvent.target.matches(RESIZABLE_IMAGES_CSS_SELECTOR)) {
          return;
        }

        var domConverter = editor.editing.view.domConverter;
        var imageView = domConverter.domToView(domEvent.target);
        var widgetView = imageView.findAncestor({
          classes: IMAGE_WIDGETS_CLASSES_MATCH_REGEXP
        });

        var resizer = _this.editor.plugins.get(WidgetResize).getResizerByViewElement(widgetView);

        if (resizer) {
          // There are rare cases when the image will be triggered multiple times for the same widget, e.g. when
          // the image's source was changed after upload (https://github.com/ckeditor/ckeditor5/pull/8108#issuecomment-708302992).
          resizer.redraw();
          return;
        }

        var mapper = editor.editing.mapper;
        var imageModel = mapper.toModelElement(widgetView);
        resizer = editor.plugins.get(WidgetResize).attachTo({
          unit: editor.config.get('image.resizeUnit'),
          modelElement: imageModel,
          viewElement: widgetView,
          editor: editor,
          getHandleHost: function getHandleHost(domWidgetElement) {
            return domWidgetElement.querySelector('img');
          },
          getResizeHost: function getResizeHost() {
            // Return the model image element parent to avoid setting an inline element (<a>/<span>) as a resize host.
            return domConverter.viewToDom(mapper.toViewElement(imageModel.parent));
          },
          // TODO consider other positions.
          isCentered: function isCentered() {
            var imageStyle = imageModel.getAttribute('imageStyle');
            return !imageStyle || imageStyle == 'block' || imageStyle == 'alignCenter';
          },
          onCommit: function onCommit(newValue) {
            // Get rid of the CSS class in case the command execution that follows is unsuccessful
            // (e.g. Track Changes can override it and the new dimensions will not apply). Otherwise,
            // the presence of the class and the absence of the width style will cause it to take 100%
            // of the horizontal space.
            editingView.change(function (writer) {
              writer.removeClass(RESIZED_IMAGE_CLASS, widgetView);
            });
            editor.execute('resizeImage', {
              width: newValue
            });
          }
        });
        resizer.on('updateSize', function () {
          if (!widgetView.hasClass(RESIZED_IMAGE_CLASS)) {
            editingView.change(function (writer) {
              writer.addClass(RESIZED_IMAGE_CLASS, widgetView);
            });
          }
        });
        resizer.bind('isEnabled').to(_this);
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [WidgetResize];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageResizeHandles';
    }
  }]);

  return ImageResizeHandles;
}(Plugin);

export { ImageResizeHandles as default };